import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  min-height: ${({theme}) => theme.responsive ? '122px' : '125px'};
  margin-top: 24px;

  .slots-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${({theme}) => theme.responsive ? '122px' : '125px'};
    width: 100%;
    > div {



      width: 30px;
      height: 30px;
    }
  }

  .time-slot {
    margin-right: 16px;
    margin-bottom: 12px;
  }
`;
